import React from 'react';
import { useNavigate } from 'react-router-dom';

interface RightButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

interface CommonHeaderProps {
  title?: string;
  onBackClick?: () => void;
  backTo?: string; // route to navigate to instead of using onBackClick
  rightButton?: RightButtonProps;
  className?: string;
  variant?: 'dark' | 'light'; // for different color schemes
  layout?: 'absolute' | 'static'; // for different positioning approaches
}

const CommonHeader: React.FC<CommonHeaderProps> = ({
  title,
  onBackClick,
  backTo,
  rightButton,
  className = "",
  variant = "dark",
  layout = "absolute"
}) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else if (backTo) {
      navigate(backTo);
    } else {
      navigate(-1);
    }
  };

  const isDark = variant === 'dark';
  const textColor = isDark ? 'text-white' : 'text-gray-900';
  const strokeColor = isDark ? 'white' : 'currentColor';
  
  const isAbsolute = layout === 'absolute';
  const containerClasses = isAbsolute 
    ? `absolute top-0 left-0 right-0 z-20 px-4 pt-4 pb-2 flex justify-between items-center`
    : `relative flex items-center w-full h-full`;
  
  const buttonClasses = `bg-transparent ${textColor} border-0`;
    
  const buttonStyle = isAbsolute 
    ? { marginTop: '15px', marginLeft: '10px' }
    : {};

  if (isAbsolute) {
    return (
      <div className={`${containerClasses} ${className}`}>
        <button 
          onClick={handleBackClick}
          className={buttonClasses}
          style={buttonStyle}
        >
          <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.6663 10H3.33301M3.33301 10L8.33301 5M3.33301 10L8.33301 15" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        
        {title && (
          <h1 className={`text-[18px] ${textColor} font-medium absolute left-1/2 transform -translate-x-1/2`} style={{ marginTop: '9px' }}>
            {title}
          </h1>
        )}
        
        <div className="flex items-center space-x-4">
          {rightButton ? (
            <button 
              onClick={rightButton.onClick}
              className={rightButton.className || `bg-transparent ${textColor} border-0 relative`}
              style={rightButton.style}
            >
              {rightButton.children}
            </button>
          ) : (
            <div>{/* Empty space for consistency */}</div>
          )}
        </div>
      </div>
    );
  }

  // Static layout for constrained containers like legal pages
  return (
    <div className={`${containerClasses} ${className}`}>
      <button 
        onClick={handleBackClick}
        className={buttonClasses}
        style={buttonStyle}
      >
        <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6663 10H3.33301M3.33301 10L8.33301 5M3.33301 10L8.33301 15" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
      
             {title && (
         <h1 className={`text-[18px] ${textColor} font-medium absolute left-1/2 transform -translate-x-1/2`} style={{ marginTop: '9px' }}>
           {title}
         </h1>
       )}
      
      {rightButton && (
        <button 
          onClick={rightButton.onClick}
          className={rightButton.className || `bg-transparent ${textColor} border-0`}
          style={rightButton.style}
        >
          {rightButton.children}
        </button>
      )}
    </div>
  );
};

export default CommonHeader; 